<template>
  <VanOverlay :show="modalStore.showHelperModal" z-index="1000">
    <div class="p-10 flex flex-col bg-[rgba(0,0,0,0.7)] h-full" @click.stop>
      <h1
        v-if="$t(`helper.${modalStore.helperType}.title`)"
        class="text-center text-2xl my-5 font-medium"
      >
        {{ $t(`helper.${modalStore.helperType}.title`) }}
      </h1>
      <VanSwipe
        ref="swiper"
        indicator-color="white"
        :loop="false"
        @change="(idx:number) => (activeIdx = idx)"
      >
        <VanSwipeItem
          v-for="help in modalStore.helperList"
          class="text-center flex justify-center"
        >
          <img
            :src="help.img"
            alt=""
            class="h-full pointer-events-none"
            crossorigin="anonymous"
          />
        </VanSwipeItem>
      </VanSwipe>

      <div class="px-2 text-center my-4">
        {{ $t(modalStore.helperList[activeIdx].content) }}
      </div>

      <div class="flex justify-around">
        <button
          :class="[
            'btn btn-md',
            activeIdx !== modalStore.helperList.length - 1
              ? ' '
              : 'btn-primary',
          ]"
          @click="clickOk"
        >
          {{ $t(`Buttons.ok`) }}
        </button>

        <button
          v-if="activeIdx !== modalStore.helperList.length - 1"
          class="btn btn-md btn-primary"
          @click="clickNext"
        >
          {{ $t(`Buttons.next`) }}
        </button>
      </div>
    </div>
  </VanOverlay>
</template>

<script lang="ts" setup>
import { useGlobalModal } from "@/stores/globalModal";
import { sessionStorageSet } from "@/tools/sessionStorage";
import { showImagePreview } from "vant";
import { SwipeInstance } from "vant/es";
import { ref } from "vue";

const modalStore = useGlobalModal();

const swiper = ref<null | SwipeInstance>(null);
const activeIdx = ref(0);

const clickImg = (idx: number) => {
  showImagePreview({
    images: modalStore.helperList.map((v) => v.img),
    startPosition: idx,
  });
};

const clickNext = () => {
  if (swiper.value) {
    swiper.value.next();
  }
};

const clickOk = () => {
  sessionStorageSet(`helper.${modalStore.helperType}`, 1);
  modalStore.showHelperModal = false;
};
</script>
